import {
  getAllDefaultValuesFromMetadata,
  getArgumentNamesFromMetadata,
  getDefaultValueFromMetadata,
  getInitialValuesForDocumentation,
  makeArgumentsPrivate,
  mergeMetadata,
  pickArgs,
  setupDocumentationData,
  sortMetadata,
} from './metadata/helpers';

import {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  MENU_ARGS,
  POSITIONING_ARGS,
} from './metadata/shared-arguments';

// Re-export all helpers
export {
  getAllDefaultValuesFromMetadata,
  getArgumentNamesFromMetadata,
  getDefaultValueFromMetadata,
  getInitialValuesForDocumentation,
  makeArgumentsPrivate,
  mergeMetadata,
  pickArgs,
  setupDocumentationData,
  sortMetadata,
};

// Re-export all shared arguments
export {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  MENU_ARGS,
  POSITIONING_ARGS,
};

export default {
  getAllDefaultValuesFromMetadata,
  getArgumentNamesFromMetadata,
  getDefaultValueFromMetadata,
  getInitialValuesForDocumentation,
  makeArgumentsPrivate,
  mergeMetadata,
  pickArgs,
  setupDocumentationData,
  sortMetadata,
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  MENU_ARGS,
  POSITIONING_ARGS,
};
